import { AnalyticsBrowser } from '@segment/analytics-next';

export interface SegmentConfigOptions {
  writeKey: string;
  enabled: boolean;
  disableClientPersistence?: boolean;
}

/**
 * Used as fallback when Navigator.userAgentData is not available (iOS devices)
 */
function detectPlatformFromUserAgent(userAgent: string) {
  const isIOS = /iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/i.test(userAgent) && /Mobile/i.test(userAgent));
  const isAndroid = /Android/.test(userAgent);
  const isMobile = /Mobile|Android|iPhone|iPad|iPod/.test(userAgent);

  return {
    mobile: isMobile,
    platform: isIOS ? 'iOS' : isAndroid ? 'Android' : 'Unknown',
  };
}

export class SegmentConfig extends AnalyticsBrowser {
  constructor({ writeKey, enabled, disableClientPersistence }: SegmentConfigOptions) {
    super();

    if (enabled) {
      this.load({ writeKey }, disableClientPersistence ? { disableClientPersistence } : undefined).catch((error) => {
        console.warn('[Segment] Analytics failed to load:', error?.message);
      });

      this.addSourceMiddleware(({ payload, next }) => {
        if (payload.obj.context && !payload.obj.context.userAgentData && typeof navigator !== 'undefined' && navigator.userAgent) {
          const userAgentData = detectPlatformFromUserAgent(navigator.userAgent);
          payload.obj.context.userAgentData = userAgentData;
        }
        next(payload);
      });
    }
  }
}
